<template>
  <q-chip
    :color="reportStatusColor(report.status)"
    text-color="white"
    class="chip text-center"
    dense
    :square="flat"
    style="width: 85px;"
  >
    {{ reportStatusName(report.status) }}
  </q-chip>
</template>

<script>
import statusMixin from './statusMixin'

export default {
  mixins: [statusMixin],
  props: {
    report: {
      required: true,
      type: Object
    },
    flat: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.chip {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
</style>
